import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SwiperSlide } from 'swiper/react';
import { filesListingSuccess } from '../../actions/files';
import { loadProjectByIdSuccess, loadRecommendationsSuccess } from '../../actions/project';
import { loadStepsByProjectSuccess } from '../../actions/step';
import { fakeActions } from '../../constants/fake-actions';
import { fakeFileList } from '../../constants/fake-file-list';
import { fakeProject } from '../../constants/fake-project';
import { fakeProjectSteps } from '../../constants/fake-project-steps';
import { fakeRecommendations } from '../../constants/fake-recommendations';
import { projectSelector, selectedProjectSelector } from '../../selectors';
import { filesListSelector, rootFilesSelector } from '../../selectors/file';
import { stepsMetaSelector } from '../../selectors/step';
import ActionItem from '../action-item';
import DetailsContainer from '../container-details';
import MapContainer from '../container-map';
import StatusContainer from '../container-status';
import { MyActionsContent, MyActionsStyled, MyActionsTitle } from '../my-actions/styled';
import PageCreateProject from '../overlay-create-project/page-create-project';
import PageParameter from '../page-parameter';
import SwiperStyled from '../swiper/SwiperStyled';
import FilesView from '../view-files';
import ViewStepsV2 from '../view-steps/steps-v2';
import { FirstSlideContentWrapper, SecondSlideContentWrapper, ThirdSlideContentWrapper } from './Layouts/DashboardMobile';
import { FilesAndStepsContainer } from './Layouts/DashboardTablet';
import { DashboardContentTopBlock, DashboardContentTopBlockColFirst, DashboardContentTopBlockColSecond, DashboardContentTopBlockLineFirst, DashboardContentTopBlockLineSecond, DashboardDesktopStyled } from './Layouts/styled';
import { BottomBlock, PageCreateProjectContainer, ProjectBody, StepsBlock, ViewProject } from './styled';
const PageProjectDraft = () => {
  const dispatch = useDispatch();
  const selectedProject = useSelector(selectedProjectSelector);
  const {
    workTypes,
    page
  } = useSelector(projectSelector);
  const files = useSelector(filesListSelector);
  const rootFiles = useSelector(rootFilesSelector);
  const metaSteps = useSelector(stepsMetaSelector);
  const [{
    isMobile,
    isTabletOrMobile
  }, setState] = useState({
    isMobile: false,
    isTabletOrMobile: false
  });
  const setIsMobile = () => {
    setState(prev => ({
      ...prev,
      isMobile: window.innerWidth < 769,
      isTabletOrMobile: window.innerWidth < 1025
    }));
  };
  React.useEffect(() => {
    setIsMobile();
    window.addEventListener('resize', setIsMobile);
    return () => {
      window.removeEventListener('resize', setIsMobile);
    };
  }, []);
  React.useEffect(() => {
    dispatch(loadProjectByIdSuccess(fakeProject));
    dispatch(loadStepsByProjectSuccess(fakeProjectSteps));
    dispatch(loadRecommendationsSuccess(fakeRecommendations));
    dispatch(filesListingSuccess(fakeFileList));
  }, []);
  const renderActions = () => {
    return /*#__PURE__*/React.createElement(MyActionsStyled, null, /*#__PURE__*/React.createElement(MyActionsTitle, null, "Actions"), /*#__PURE__*/React.createElement(MyActionsContent, null, fakeActions.map(action => /*#__PURE__*/React.createElement(ActionItem, {
      key: action.id,
      action: action
    }))));
  };
  const renderFiles = () => {
    return /*#__PURE__*/React.createElement(FilesView, {
      files: files,
      rootFiles: rootFiles,
      loadingFilesIds: [],
      deleteFile: () => {},
      handleFileUpload: () => {},
      getFileDownloadLink: () => {},
      previewFile: () => {},
      uploadingFilesDescriptors: [],
      accessToken: ""
    });
  };
  const renderSteps = () => {
    return /*#__PURE__*/React.createElement(StepsBlock, null, /*#__PURE__*/React.createElement(ViewStepsV2, {
      steps: metaSteps
    }));
  };
  const renderMobileDash = () => {
    return /*#__PURE__*/React.createElement(SwiperStyled, null, /*#__PURE__*/React.createElement(SwiperSlide, null, /*#__PURE__*/React.createElement(FirstSlideContentWrapper, null, /*#__PURE__*/React.createElement(MapContainer, {
      project: fakeProject
    }), /*#__PURE__*/React.createElement(DetailsContainer, {
      project: fakeProject
    }), /*#__PURE__*/React.createElement(StatusContainer, {
      project: fakeProject
    }))), /*#__PURE__*/React.createElement(SwiperSlide, null, /*#__PURE__*/React.createElement(SecondSlideContentWrapper, null, renderActions(), renderFiles())), /*#__PURE__*/React.createElement(SwiperSlide, null, /*#__PURE__*/React.createElement(ThirdSlideContentWrapper, null, renderSteps())));
  };
  const renderTabletDash = () => {
    return /*#__PURE__*/React.createElement(SwiperStyled, null, /*#__PURE__*/React.createElement(SwiperSlide, null, renderDashboardTopBlock()), /*#__PURE__*/React.createElement(SwiperSlide, null, /*#__PURE__*/React.createElement(FilesAndStepsContainer, null, renderFiles(), renderSteps())));
  };
  const renderDashboardTopBlock = () => {
    return /*#__PURE__*/React.createElement(DashboardContentTopBlock, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockLineFirst, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockColFirst, null, /*#__PURE__*/React.createElement(MapContainer, {
      project: fakeProject
    })), /*#__PURE__*/React.createElement(DashboardContentTopBlockColSecond, null, renderActions())), /*#__PURE__*/React.createElement(DashboardContentTopBlockLineSecond, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockColFirst, null, /*#__PURE__*/React.createElement(StatusContainer, {
      project: fakeProject
    })), /*#__PURE__*/React.createElement(DashboardContentTopBlockColSecond, null, /*#__PURE__*/React.createElement(DetailsContainer, {
      project: fakeProject
    }))));
  };
  return selectedProject && workTypes ? /*#__PURE__*/React.createElement(ViewProject, null, /*#__PURE__*/React.createElement(ProjectBody, {
    className: "projectBody"
  }, isTabletOrMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, page === 'projet' ? /*#__PURE__*/React.createElement(BottomBlock, null, isMobile ? renderMobileDash() : renderTabletDash()) : page === 'parametres' ? /*#__PURE__*/React.createElement(PageParameter, null) : page === 'page-create-new-project' ? /*#__PURE__*/React.createElement(PageCreateProjectContainer, null, /*#__PURE__*/React.createElement(PageCreateProject, {
    showTitle: false
  })) : null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomBlock, null, /*#__PURE__*/React.createElement(DashboardDesktopStyled, null, renderDashboardTopBlock(), renderFiles())), renderSteps()))) : null;
};
export default PageProjectDraft;